import { useEffect, useState } from "react";
import { loader } from "react-global-loader";
import { Icon } from "@iconify/react";
import { Button } from "../../components/ui/button";
import Common from "../../helper/common";
import AdvanceTable from "../../components/advanceTable";
import { useNavigate } from "react-router-dom";
import { useQueryParams } from "../../contexts/queryParamsContext";
import { PaymentTypeEnum, SearchTypeEnum } from "../../constants/appConstant";
import { AppSearchSectionSelect, AppSearchSelect, AppSelect } from "../../components/appComponents";

const AdminClubAccounts = () => {
  const [ClubAccount, setClubAccount] = useState([]);
  const [loading, setLoading] = useState(true);
  const { params, setParams } = useQueryParams();
  const [accountList, setAccountList] = useState([]);
  const[clubId,setClubId]=useState(null);
  const[paymentTypeId,setPaymentTypeId]=useState(null);

  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [id, setId] = useState(null);
    
  
  

  // const GetClubAccounts = async () => {
  //   setLoading(true);
  //   const response = await Common.ApiService.getInstance().request(
  //     "GetClubAccountListFromAdmin",
  //   );
  //   let data = response?.data?.map((item) => ({
  //     ...item,
  //     isAcceptOnline: item.isAcceptOnline ? "Yes" : "No",
  //     isReceiptRequired: item.isReceiptRequired ? "Yes" : "No",
  //   }));
  //   setClubAccount(data);
  //   setLoading(false);
  // };

  const getClubAccount = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetClubsDDL"
      );
      const data = [
        { id: null, name: "All" },
        ...(response?.data ?? []),
      ];

      setAccountList(data);
    });
  };

  const resetFilters = () => {
    // setSearch(null);
    setClubId(null);
    setPaymentTypeId(null);
  };

const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
     setLoading(true);
    const response = await Common.ApiService.getInstance().request(
      "GetClubAccountListFromAdmin",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        isactive: true,
        recordsToDisplay,
        clubId,
        paymentTypeId

      },
      "Post"
    );

    if (response?.data) {
      debugger;
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          isAcceptOnline: item.isAcceptOnline ? "Yes" : "No",
          isReceiptRequired: item.isReceiptRequired ? "Yes" : "No",
         
        })),
      };

      setData(obj);
      setLoading(false);

    }
  };


  
  useEffect(() => {
    //loader.hide();
    // GetClubAccounts();
    getClubAccount();
    getData();
  }, [clubId,paymentTypeId]);

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to delete this Club Account?",
      "Delete Club Account"
    );
    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteClubAccountFromAdmin?id=${id}`,
        {},
        "Delete"
      );
      Common.SweetAlert.alert(resp.message, "success");
      setTimeout(() => {
        // GetClubAccounts(1);
        getData(1);
      }, 500);
    }
  };

  //  const _handleEdit = async (id) => {
   
  //     //  setLoading(true);
  //   const response = await Common.ApiService.getInstance().request(
  //     `GetClubAccountFromAdmin?id=${id}`,
  //   );
  //   let data = response?.data?.map((item) => ({
  //     ...item,
  //     isAcceptOnline: item.isAcceptOnline ? "Yes" : "No",
  //     isReceiptRequired: item.isReceiptRequired ? "Yes" : "No",
  //   }));
  //   // setClubAccount(data);
  //   setData(data);
  //   setLoading(false);
  // };

  const _handleOnChange = async (obj) => {
    let resp = await Common.ApiService.getInstance().request(
      `ActiveDeactiveAccountFromAdmin?id=${obj.id}&isActive=${!obj.isActive}`,
      {},
      "POST"
    );

    Common.SweetAlert.alert(resp.message, "success");
    setTimeout(() => {
      setData(
        data.map((item) =>
          item.id == obj.id ? { ...item, isActive: !item.isActive } : item
        )
      );
      //GetClubAccounts(1);
      getData(1);
    }, 300);
  };

  const _thead = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    {
      title: "Payment Type",
      type: "text",
      isVisible: true,
      key: "paymentTypeName",
    },
    { title: "Account Name", type: "text", isVisible: true, key: "name" },
    { title: "Club", type: "text", isVisible: true, key: "clubName" },
    { title: "Bank Name", type: "text", isVisible: true, key: "bankName" },
    {
      title: "Payment Gateway",
      type: "text",
      isVisible: true,
      key: "paymentGatewayName",
    },
    {
      title: "Accept Online",
      type: "text",
      isVisible: true,
      key: "isAcceptOnline",
    },
    {
      title: "Receipt Required",
      type: "text",
      isVisible: false,
      key: "isReceiptRequired",
    },
    {
      title: "Is Active",
      type: "toggle",
      isVisible: false,
      key: "isActive",
      onChanged: (item) => _handleOnChange(item),
    },
  ];

  const actions = [
    {
      type: "edit",
      onClick: (val) => {
        setParams({
          ...params,
          accountId: val.id,
        });
        navigate(`/app/adminAddAccount`);
      },
      // onClick: async (val) => {
      // await getData(1, '', null, val.id); 
      // navigate(`/app/adminAddAccount`);
      // },
      visibleProp: "canEdit",
      visibleValue: true,
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
      visibleProp: "canDelete",
      visibleValue: true,
    },
  ];

  if (loading) {
    return <div>Loading...</div>;
  }

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  const _addBtn = () => (
    <Button onClick={() => {
      setParams({ ...params, accountId: null });
      navigate("/app/adminAddAccount")}}>
      <span className="text-xl mr-1">
        <Icon icon="icon-park-outline:plus" />
      </span>
      Add Account
    </Button>
  );

  return (
    <>
    <div className="md:grid md:grid-cols-6 gap-3 h-150 w-150 ">
       <AppSearchSelect
          value={clubId}
          onChange={setClubId}
          placeholder={"All"}
          label={"Club"}
          data={accountList}
          className={"mb-3 col-span-1"}
        />
          <AppSearchSelect
          value={paymentTypeId}
          onChange={setPaymentTypeId}
          placeholder={"All"}
          label={"Payment Type"}
          data={[
          { id: null, name: "All" },
          { id: PaymentTypeEnum.Cash, name: "Cash" },
          { id: PaymentTypeEnum.Online, name: "Online" },
          {
            id: PaymentTypeEnum.Pay_On_Club,
            name: "Pay On Club",
          },
          {
            id: PaymentTypeEnum.Online_Partial_Pay,
            name: "Online Partial Pay",
          },
          {
            id: PaymentTypeEnum.Payment_GateWay,
            name: "Payment Gateway",
          },]}
          // onChange={(val) => setPaymentTypeId(Number(val))}
          className={"mb-3 col-span-1"}
        />
        <Button className="lg:mt-6 h-8 mb-5" onClick={resetFilters}>
          Reset Filter
        </Button>
    </div>

    {data?.data && (
      <AdvanceTable
        title={"Club Accounts"}
        columns={_thead.filter((item) => item.isVisible)}
        // data={{ data: ClubAccount }}
        data={data}
        getData={getData}
        addButton={_addBtn}
        showPagination
        showAddButton
        actionButtons={actions}
        updateTrigger={_addUpdateTrigger}
        search={SearchTypeEnum.Local_Search}
        searchInputClassName="custom-search-mobile "
      />
      )}
    </>
  );
};

export default AdminClubAccounts;
